export default {"src":"/_next/static/media/payment-apps.120bb0c7.svg","height":552,"width":552,"blurWidth":0,"blurHeight":0};